import { takeEvery } from 'redux-saga/effects';

import * as bookingCardActions from 'store/modules/bookingCard';

import { confirmBooking } from './utils';

export default function* listenConfirm() {
  yield takeEvery(bookingCardActions.confirm.type, confirmBooking);
}
